import React from 'react';
import { connect } from 'react-redux';
import { Route } from 'react-router-dom';

import { isValidToken } from '../../redux/session/selectors';
import { AppState } from '../../redux/state';
import PrivateRoute from './PrivateRoute';

const AuthenticatedRoute = (props: AuthenticatedRouteProps) => {
  const { isAuthenticated, location } = props;
  const redirect = {
    pathname: '/',
    state: { from: location },
  };
  return (
    <PrivateRoute
      canActivate={isAuthenticated}
      redirectTo={redirect}
      {...props}
    />
  );
};

interface AuthenticatedRouteProps extends React.ComponentProps<typeof Route> {
  isAuthenticated: boolean;
}

const mapStateToProps = (state: AppState) => ({
  isAuthenticated: isValidToken(state),
});

export default connect(mapStateToProps)(AuthenticatedRoute);
